import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZzzConfigService } from 'src/app/zzz/core/config/config.service';
import { CreerCommentairePlanTravail, ReponseCommentairePlanTravail } from '../models/commentaire-plans-travail';

@Injectable({
  providedIn: 'root'
})
export class CommentairePlansTravailService {
  private urlApi: string;

  constructor(
    private httpClient: HttpClient,
    private configService: ZzzConfigService
  ) {
    this.urlApi = this.configService.get().authApiEndPoint;
  }

  public creerCommentaire(commentaire: CreerCommentairePlanTravail) {
    const url = `${this.urlApi}/sigtapi/commentaire-plan-travail`;
    return this.httpClient.post<ReponseCommentairePlanTravail>(
      url,
      { commentairePlanTravail: commentaire }
    );
  }

  public supprimerCommentaire(id: number) {
    const url = `${this.urlApi}/sigtapi/commentaire-plan-travail/?commentaireplantravailid=${id}`;
    return this.httpClient.delete<ReponseCommentairePlanTravail>(
      url
    );
  }
}
